import type { PropsWithChildren } from "react";

import AppsLockedOverlay from "../AppsLockedOverlay/AppsLockedOverlay";

import { StyledAppsLockedOverlayWrapper, StyledAppsLockedTableOverlayContainer } from "./styles";

type Props = PropsWithChildren<{
    isAppsLocked: boolean;
}>;

const AppsLockedTableOverlay = ({ isAppsLocked, children }: Props) =>
    isAppsLocked ? (
        <StyledAppsLockedTableOverlayContainer data-automation="apps-locked-table-overlay">
            <StyledAppsLockedOverlayWrapper>
                <AppsLockedOverlay />
            </StyledAppsLockedOverlayWrapper>
        </StyledAppsLockedTableOverlayContainer>
    ) : (
        children
    );

export default AppsLockedTableOverlay;
